// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2rYoH","inputWrap":"Table_inputWrap__1_Fdo","col":"Table_col__1wQSy","bmiTooltip":"Table_bmiTooltip__3Xi4e"};